<template>
  <div class="collapse-wrapper">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "AppCollapse",
  props: {
    accordion: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.$on("close-all", this.closeAll);
  },
  methods: {
    closeAll(calleeIndex) {
      if (this.accordion) {
        this.$children.forEach(child => {
          if (child._uid !== calleeIndex) {
            child.isOpen = false;
          }
        });
      }
    }
  }
};
</script>

<style scoped lang="scss" type="text/scss">
.icon {
  font-size: 34px;
}

.VueCarousel-pagination {
  position: absolute;
  bottom: 0%;
}

.VueCarousel-navigation-button {
  display: none;
  font-size: 56px;
  color: #a84339 !important;
  line-height: 1;
  background-color: rgba(0, 0, 0, 0.6) !important;

  @media (max-width: 1024px) {
    font-size: 40px;
  }
}

.VueCarousel:hover,
.VueCarousel:focus {
  .VueCarousel-navigation-button {
    display: block !important;
  }
}

.VueCarousel-navigation-prev {
  transform: translateY(-50%) translateX(0%) !important;

  @media (max-width: 768px) {
    font-size: 28px;
  }
}

.VueCarousel-navigation-next {
  transform: translateY(-50%) translateX(0) !important;

  @media (max-width: 768px) {
    font-size: 28px;
  }
}
</style>
